import React from "react";

export const LOGO_SRC = `${process.env.PUBLIC_URL}/assets/jpsy-logo.png`;
export default function Logo({ className = "", ...props }) {
  return <img src={LOGO_SRC} alt="JPSY" className={className} {...props} />;
}
